// External deps
import * as Yup from 'yup';

// Internal deps
import {
  isArrayOfRequired,
  isObjectRequired,
  isStringRequired
} from '../../../CreateServiceRequest/ValidationSchemaCSR';

const generateRequestTemplateValidationSchema = Yup.object().shape({
  currentStep: Yup.number(),
  templateName: Yup.string().required(),
  ubication: Yup.object().shape({
    ubicationType: isObjectRequired('Debe seleccionar un tipo de ubicación')
  }),
  // Cada acordion contiene servicios, proveedores, aprovadores y comunicadores
  // accordions => request => {step, service, provider, }
  accordions: Yup.array().of(
    Yup.object().shape({
      accordionStep: Yup.number(),
      service: Yup.object().shape({
        service: isObjectRequired('Debe seleccionar un servicio'),
        probDate: Yup.string().nullable(),
        needDate: Yup.string().nullable(),
        description: isStringRequired('Ingrese una descripción').min(
          1,
          'Debe ingresar al menos un caracter'
        )
      }),
      provider: Yup.object().shape({
        providers: isArrayOfRequired({
          arrayContent: Yup.object().shape({
            provider: isObjectRequired('Ingrese proveedor'),
            contract: isObjectRequired('Seleccione un contrato'),
            businessUnit: isObjectRequired('Seleccione una unidad de negocio'),
            notificate: isObjectRequired('Seleccione notificador')
          }),
          requiredMessage: 'Ingrese proveedor',
          minLength: 1,
          aLeastMessage: 'Debe ingresar al menos un proveedor'
        })
      }),
      approver: Yup.object().shape({
        approvers: isArrayOfRequired({
          arrayContent: Yup.object(),
          requiredMessage: 'Ingrese aprobador',
          minLength: 1,
          aLeastMessage: 'Debe ingresar al menos un aprobador'
        })
      }),
      communicate: Yup.object().shape({
        receivers: isArrayOfRequired({
          arrayContent: Yup.object(),
          requiredMessage: 'Ingrese destinatario',
          minLength: 1,
          aLeastMessage: 'Debe ingresar al menos un destinatario'
        })
      })
    })
  )
});

export default generateRequestTemplateValidationSchema;
